import useSafeState from '../../utils/safe-state';
import React, {useEffect} from 'react';
import {Form, Row, Col, Input, Button, message, Switch, Select, InputNumber} from 'antd';
import {useAxios} from '../../utils/hooks';
import {AxiosResponse} from "axios";
import {Trans} from "@lingui/macro";
import {i18n} from "@lingui/core";
import {I18nProvider} from "@lingui/react";
import {SelectType} from "#/interfaces/SelectType";
import ItemModel from "../../models/dto/item-model";

interface Interface {
    data?: any;
    mode?: "Edit" | "Add new";
    onClose?: () => void;
}


const ItemForm = (props: Interface) => {

    const [loading, setLoading] = useSafeState(false);
    const axiosInstance = useAxios(process.env.REACT_APP_API_BASE_URL + "");
    const axiosInstanceBackend = useAxios(process.env.REACT_APP_API_BASE_URL + "")
    const [autoCompleteOptions, setAutoCompleteOptions] = useSafeState<any>();
    const config = {headers: {'Content-Type': 'application/json'}};
    const [active, setActive] = useSafeState(true);

    const data = props.data || {};
    const [form] = Form.useForm();

    let isEditMode = false;

    useEffect(() => getFormData(), []);

    useEffect(() => {

        form.resetFields();

        if (props.mode === "Edit") {

            let fieldsValues = [];
            for (const [key, value] of Object.entries(data)) {
                fieldsValues.push({name: key, value: value});
            }
            form.setFields(fieldsValues);

            isEditMode = true;
        } else if (props.mode === "Add new") {
            isEditMode = false;
        }
    }, [])

    const onReset = () => {
        form.resetFields();
    };

    const antdContext: any = (text: string) => {
        return <I18nProvider i18n={i18n}>
            <Trans>{text}</Trans>
        </I18nProvider>;
    }

    const openNotification = (status: any) => {
        if (status === "error") {
            message.error(antdContext('Hiba mentés közben')).then(r => {
                console.log(r)
            });
        } else if (status === "success") {
            message.success(antdContext('Sikeres mentés'));
        } else {
            message.info(antdContext('Ismeretlen hiba')).then(r => {
                console.log(r)
            })
        }
        if (props.onClose) {
            props.onClose();
        }
    };

    const handleEdit = () => {

        if (axiosInstance.current != null) {
            const obj = {
                id: {
                    itemNo: form.getFieldValue(["itemNo"]),
                    supplier: {
                        code: form.getFieldValue(["supplier"])
                    }
                },
                active: form.getFieldValue(["active"]),
                nameHun: form.getFieldValue(["nameHun"]),
                nameEng: form.getFieldValue(["nameEng"]),
                piecePerBox: form.getFieldValue(["piecePerBox"]),
                version: form.getFieldValue(["version"])
            };
            setLoading(true);
            axiosInstance.current.put(ItemModel.url + "/id?itemNo=" + form.getFieldValue(["itemNo"]) + "&supplierCode=" + form.getFieldValue(["supplier"]), obj,
                config).then(() => {
                openNotification("success");
                setLoading(false);

            }).catch(function (error: any) {
                openNotification("error");
                console.log(error)
                setLoading(false);
            });
        }
    }

    const handleUploadCsv = () => {

        if (axiosInstance.current != null) {
            setLoading(true);
            const formData = new FormData();

            axiosInstance.current.post("/resource/messages/upload-csv", formData,
                {headers: {'Content-Type': 'multipart/form-data'}}).then(() => {
                openNotification("success");
                setLoading(false);
            }).catch(function (error: any) {
                openNotification("error");
                console.log(error)
                setLoading(false);
            });
        }
    }

    const handleAddNew = () => {

        if (axiosInstance.current != null) {
            setLoading(true);
            axiosInstance.current.post("/resource/items", {
                    id: {
                        itemNo: form.getFieldValue(["itemNo"]),
                        supplier: {
                            code: form.getFieldValue(["supplier"])
                        }
                    },
                    active: active,
                    nameHun: form.getFieldValue(["nameHun"]),
                    nameEng: form.getFieldValue(["nameEng"]),
                    piecePerBox: form.getFieldValue(["piecePerBox"])
                },
                config)
                .then(function (response: AxiosResponse<any>) {
                    openNotification("success");
                    setLoading(false);

                }).catch(function (error: any) {
                openNotification("error");
                console.log(error)
                setLoading(false);
            });
        }
    }

    const getFormData = () => {

        if (!axiosInstanceBackend.current) {
            return;
        }

        axiosInstanceBackend.current.get('/resource/suppliers')
            .then(function (response: AxiosResponse<any>) {
                if (Array.isArray(response.data)) {
                    let supplierArray: Array<SelectType> = [];
                    response.data.forEach(value => {

                        const label = value.code;

                        supplierArray.push(
                            {
                                label: label,
                                value: label,
                            }
                        )
                    });
                    setAutoCompleteOptions(supplierArray);

                }

            })
            .catch(function (error: any) {
                console.log(error);//TODO::EndIt
            });

    };

    const onChange = () => {
        setActive(!active);
    }

    return (
        <Form id={props.mode} form={form} layout="vertical"
              onFinish={() => props.mode === "Edit" ? handleEdit() : handleAddNew()}>
            <>
                <Row gutter={24}>
                    <Col span={12}>
                        <Form.Item
                            name="itemNo"
                            label={<Trans>ItemNo</Trans>}
                            children={<Input disabled={props.mode === "Edit"}/>}
                            rules={[{
                                type: "string",
                                required: true,
                                message: <Trans>Please type an itemNo</Trans>
                            }]}
                        />
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="supplier"
                            label={<Trans>Supplier</Trans>}
                            children={
                                <Select
                                    notFoundContent={<Trans id={'No data'}/>}
                                    showSearch={true}
                                    style={{width: '100%'}}
                                    placeholder={<Trans id={'Select supplier'}></Trans>}
                                    options={autoCompleteOptions}
                                />
                            }
                            rules={[{
                                type: "string",
                                required: true,
                                message: <Trans>Please type an supplier code</Trans>
                            }]}
                        />
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={12}>
                        <Form.Item
                            name="nameHun"
                            label={<Trans>Name Hun</Trans>}
                            children={<Input disabled={false}/>}
                            rules={[{
                                type: "string",
                                required: true,
                                message: <Trans>Please type a name eng</Trans>
                            }]}
                        />
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="nameEng"
                            label={<Trans>Name Eng</Trans>}
                            children={<Input disabled={false}/>}
                            rules={[{
                                type: "string",
                                required: true,
                                message: <Trans>Please type a name eng</Trans>
                            }]}
                        />
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={8}>
                        <Form.Item
                            name="piecePerBox"
                            label={<Trans>Piece / Box</Trans>}
                            children={<InputNumber disabled={false}/>}
                            rules={[{
                                type: "number",
                                required: true,
                                message: <Trans>Please type a qty</Trans>
                            }]}
                        />
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="active"
                            label={<Trans>Active?</Trans>}
                            valuePropName="checked"
                            rules={[{
                                type: "boolean"
                            }]}
                            children={<Switch defaultChecked onChange={onChange}/>}
                        />
                    </Col>
                </Row>
            </>
            {props.mode === "Edit" ?
                <Button loading={loading} htmlType="button" type="primary" onClick={() => form.submit()}>
                    <Trans>Mentés</Trans>
                </Button>
                :
                props.mode === "Add new" ?
                    <>
                        <Button htmlType="button" style={{marginRight: 8}} onClick={() => onReset()}>
                            <Trans>Vissza</Trans>
                        </Button>
                        <Button loading={loading} htmlType="button" type="primary" style={{marginRight: 8}}
                                onClick={() => form.submit()}>
                            <Trans>Save</Trans>
                        </Button>
                    </>
                    :
                    <Button loading={loading} htmlType="button" type="primary" onClick={() => handleUploadCsv()}>
                        <Trans>Feltöltés</Trans>
                    </Button>

            }
        </Form>
    );

}
export default ItemForm;
